import type { RegisterStatus } from '@/features/publicsite/types/events/RegisterStatus';

/** Where the "Înscrie-te" button's attempt stands — what the status line under it reports. */
export const REGISTER_STATUS = {
  idle: 'idle',
  done: 'done',
  cancelled: 'cancelled',
  signin: 'signin',
  failed: 'failed',
} as const;

/**
 * What a refused registration reports, from the refusal's HTTP status (0 when there was none).
 *
 * 401/403 both mean "not signed in far enough" — the page offers the way in rather than reporting
 * a failure the visitor cannot act on.
 */
export function registerFailureStatus(httpStatus: number): RegisterStatus {
  return httpStatus === 401 || httpStatus === 403 ? REGISTER_STATUS.signin : REGISTER_STATUS.failed;
}
